module.exports = __webpack_public_path__ + "img/line-chart-icon.ffbbd24b.svg";